var _regeneratorRuntime = require("/Users/jakob/coding/matkoma/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/jakob/coding/matkoma/node_modules/@babel/runtime/helpers/asyncToGenerator");

/* global WebKitCSSMatrix */
var React = require('react');

var sleep = require('p-sleep');

var settings = {
  snapBackDuration: 300,
  maxTilt: 5,
  bouncePower: 0.2,
  swipeThreshold: 300 // px/s

};

var getElementSize = function getElementSize(element) {
  var elementStyles = window.getComputedStyle(element);
  var widthString = elementStyles.getPropertyValue('width');
  var width = Number(widthString.split('px')[0]);
  var heightString = elementStyles.getPropertyValue('height');
  var height = Number(heightString.split('px')[0]);
  return {
    x: width,
    y: height
  };
};

var pythagoras = function pythagoras(x, y) {
  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
};

var animateOut =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(element, speed) {
    var startPos, bodySize, diagonal, velocity, time, multiplier, translateString, rotateString;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            startPos = getTranslate(element);
            bodySize = getElementSize(document.body);
            diagonal = pythagoras(bodySize.x, bodySize.y);
            velocity = pythagoras(speed.x, speed.y);
            time = diagonal / velocity;
            multiplier = diagonal / velocity;
            translateString = translationString(speed.x * multiplier + startPos.x, -speed.y * multiplier + startPos.y);
            rotateString = rotationString(getRotation(element));
            element.style.transition = 'ease-out ' + time + 's';
            element.style.transform = translateString + rotateString;
            _context.next = 12;
            return sleep(time * 1000);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function animateOut(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var animateBack = function animateBack(element) {
  element.style.transition = settings.snapBackDuration + 'ms';
  var startingPoint = getTranslate(element);
  var translation = translationString(startingPoint.x * -settings.bouncePower, startingPoint.y * -settings.bouncePower);
  var rotation = rotationString(getRotation(element) * -settings.bouncePower);
  element.style.transform = translation + rotation;
  setTimeout(function () {
    element.style.transform = 'none';
  }, settings.snapBackDuration * 0.75);
  setTimeout(function () {
    element.style.transition = '10ms';
  }, settings.snapBackDuration);
};

var getSwipeDirection = function getSwipeDirection(speed) {
  if (Math.abs(speed.x) > Math.abs(speed.y)) {
    return speed.x > 0 ? 'right' : 'left';
  } else {
    return speed.y > 0 ? 'up' : 'down';
  }
};

var calcSpeed = function calcSpeed(oldLocation, newLocation) {
  var dx = newLocation.x - oldLocation.x;
  var dy = oldLocation.y - newLocation.y;
  var dt = (newLocation.time - oldLocation.time) / 1000;
  return {
    x: dx / dt,
    y: dy / dt
  };
};

var translationString = function translationString(x, y) {
  var translation = 'translate(' + x + 'px, ' + y + 'px)';
  return translation;
};

var rotationString = function rotationString(rot) {
  var rotation = 'rotate(' + rot + 'deg)';
  return rotation;
};

var getTranslate = function getTranslate(element) {
  var style = window.getComputedStyle(element);
  var matrix = new WebKitCSSMatrix(style.webkitTransform);
  var ans = {
    x: matrix.m41,
    y: matrix.m42
  };
  return ans;
};

var getRotation = function getRotation(element) {
  var style = window.getComputedStyle(element);
  var matrix = new WebKitCSSMatrix(style.webkitTransform);
  var ans = -Math.asin(matrix.m21) / (2 * Math.PI) * 360;
  return ans;
};

var dragableTouchmove = function dragableTouchmove(coordinates, element, offset, lastLocation) {
  var pos = {
    x: coordinates.x + offset.x,
    y: coordinates.y + offset.y
  };
  var newLocation = {
    x: pos.x,
    y: pos.y,
    time: new Date().getTime()
  };
  var translation = translationString(pos.x, pos.y);
  var rotCalc = calcSpeed(lastLocation, newLocation).x / 1000;
  var rotation = rotationString(rotCalc * settings.maxTilt);
  element.style.transform = translation + rotation;
  return newLocation;
};

var touchCoordinatesFromEvent = function touchCoordinatesFromEvent(e) {
  var touchLocation = e.targetTouches[0];
  return {
    x: touchLocation.clientX,
    y: touchLocation.clientY
  };
};

var mouseCoordinatesFromEvent = function mouseCoordinatesFromEvent(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
};

var swipeAlreadyReleased = false;

var TinderCard = function TinderCard(_ref2) {
  var _ref2$flickOnSwipe = _ref2.flickOnSwipe,
      flickOnSwipe = _ref2$flickOnSwipe === void 0 ? true : _ref2$flickOnSwipe,
      children = _ref2.children,
      onSwipe = _ref2.onSwipe,
      onCardLeftScreen = _ref2.onCardLeftScreen,
      className = _ref2.className;

  var handleSwipeReleased =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(element, speed) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!swipeAlreadyReleased) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              swipeAlreadyReleased = true;

              if (!(Math.abs(speed.x) > settings.swipeThreshold | Math.abs(speed.y) > settings.swipeThreshold)) {
                _context2.next = 16;
                break;
              }

              if (!flickOnSwipe) {
                _context2.next = 12;
                break;
              }

              onSwipe(getSwipeDirection(speed));
              _context2.next = 8;
              return animateOut(element, speed);

            case 8:
              element.style.display = 'none';
              onCardLeftScreen();
              _context2.next = 14;
              break;

            case 12:
              animateBack(element);
              onSwipe(getSwipeDirection(speed));

            case 14:
              _context2.next = 17;
              break;

            case 16:
              animateBack(element);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSwipeReleased(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSwipeStart = function handleSwipeStart() {
    swipeAlreadyReleased = false;
  };

  var ref = React.useCallback(function (element) {
    if (!element) {
      return;
    } // necesarry?


    var offset = {
      x: null,
      y: null
    };
    var speed = {
      x: 0,
      y: 0
    };
    var lastLocation = {
      x: 0,
      y: 0,
      time: new Date().getTime()
    };
    var mouseIsClicked = false;
    element.addEventListener('touchstart', function (ev) {
      ev.preventDefault();
      handleSwipeStart();
      offset = {
        x: -touchCoordinatesFromEvent(ev).x,
        y: -touchCoordinatesFromEvent(ev).y
      };
    });
    element.addEventListener('mousedown', function (ev) {
      ev.preventDefault();
      mouseIsClicked = true;
      handleSwipeStart();
      offset = {
        x: -mouseCoordinatesFromEvent(ev).x,
        y: -mouseCoordinatesFromEvent(ev).y
      };
    });
    element.addEventListener('touchmove', function (ev) {
      ev.preventDefault();
      var newLocation = dragableTouchmove(touchCoordinatesFromEvent(ev), element, offset, lastLocation);
      speed = calcSpeed(lastLocation, newLocation);
      lastLocation = newLocation;
    });
    element.addEventListener('mousemove', function (ev) {
      ev.preventDefault();

      if (mouseIsClicked) {
        var newLocation = dragableTouchmove(mouseCoordinatesFromEvent(ev), element, offset, lastLocation);
        speed = calcSpeed(lastLocation, newLocation);
        lastLocation = newLocation;
      }
    });
    element.addEventListener('touchend', function (ev) {
      ev.preventDefault();
      handleSwipeReleased(element, speed);
    });
    element.addEventListener('mouseup', function (ev) {
      if (mouseIsClicked) {
        ev.preventDefault();
        mouseIsClicked = false;
        handleSwipeReleased(element, speed);
      }
    });
    element.addEventListener('mouseleave', function (ev) {
      if (mouseIsClicked) {
        ev.preventDefault();
        mouseIsClicked = false;
        handleSwipeReleased(element, speed);
      }
    });
  });
  return React.createElement('div', {
    ref: ref,
    className: className
  }, children);
};

module.exports = TinderCard;